<template>
  <v-card dense style="height: 90vh;">
    <v-card-text>
      <v-row>
        <v-tabs hide-slider active-class="elevation-10" grow>
          <v-tab>Add Devices</v-tab>
          <v-tab>Add Users</v-tab>
          <v-tab-item>
            <ItemListInfo
              :disabled="disableAll"
              ref="subscriptionsToAddList"
              @on-click-add="addSubscription"
              :has-search="true"
              :has-action="true"
              :has-add-action="true"
              :dense="true"
              :headers="allSubscriptionsHeaders"
              :items="subscriptionsToAdd"
              :loading="subscriptionsLoading"
              :error-message="subscriptionsError"
              init-sort="unit.alias"/>
          </v-tab-item>
          <v-tab-item>
            <v-row>
              <v-col cols="12" sm="6">
                <v-card-title>Add users manually</v-card-title>
                <EmailForm
                  :disabled="disableAll"
                  ref="emailForm"
                  v-on:submit-form="onAddUsersManually"
                  button-text="Add"
                />
              </v-col>
              <v-col cols="12" sm="6">
                <v-card-title>Add existing users</v-card-title>
                <ItemListInfo
                  :disabled="disableAll"
                  ref="usersToAddList"
                  @on-click-add="addUser"
                  :has-search="true"
                  :has-action="true"
                  :has-add-action="true"
                  :dense="true" :headers="existingUsersHeaders"
                  :items="usersToAdd"
                  :loading="usersLoading"
                  :error-message="usersError"
                  init-sort="email"/>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs>
      </v-row>
      <hr>
      <v-row>
        <v-col cols="12" sm="6">
          <v-card-title>Added Devices</v-card-title>
          <ItemListInfo
            :disabled="disableAll"
            ref="addedSubscriptionsList"
            @on-click-remove="removeSubscription"
            :has-action="true"
            :has-remove-action="true"
            :dense="true"
            :headers="addedSubscriptionsHeaders"
            :items="addedSubscriptions"/>
        </v-col>
        <v-col cols="12" sm="6">
          <v-card-title>Added Users</v-card-title>
          <ItemListInfo
            :disabled="disableAll"
            ref="addedUsersList"
            @on-click-remove="removeEmail"
            :has-action="true"
            :has-remove-action="true"
            :dense="true"
            :headers="addedUsersHeaders"
            :items="addedUsers"/>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn :disabled="disableAll" class="secondary" @click="onClickClose">cancel</v-btn>
      <v-btn  :loading="inviting" class="primary" @click="onClickInvite" :disabled="addedUsers.length === 0 || addedSubscriptions.length === 0 || disableAll">
        Invite
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import EmailForm from './EmailForm'
import ItemListInfo from './ItemListInfo'
import bulkOperation from '../mixins/bulkOperation'

export default {
  name: 'InvitationsCreate',
  mixins: [bulkOperation],
  components: {
    EmailForm,
    ItemListInfo
  },
  data: () => ({
    inviting: false,
    disableAll: false,
    addedUsers: [],
    addedSubscriptions: [],
    addedUsersHeaders: [
      {
        text: 'Email',
        align: 'left',
        value: 'email'
      }
    ],
    existingUsersHeaders: [
      {
        text: 'Email',
        align: 'left',
        value: 'email'
      }
    ],
    addedSubscriptionsHeaders: [
      {
        text: '',
        align: 'left',
        dense: true,
        value: 'transientFamily',
        sortable: false
      },
      {
        text: 'Alias',
        value: 'unit.alias'
      },
      {
        text: 'Note',
        value: 'unit.notes'
      },
      {
        text: 'Subscription number',
        value: 'subscriptionNumber'
      }
    ],
    allSubscriptionsHeaders: [
      {
        text: '',
        align: 'left',
        dense: true,
        value: 'transientFamily',
        sortable: false
      },
      {
        text: 'Alias',
        value: 'unit.alias'
      },
      {
        text: 'Note',
        value: 'unit.notes'
      },
      {
        text: 'Subscription number',
        value: 'subscriptionNumber'
      }
    ]
  }),

  methods: {
    onClickInvite: function () {
      let subscriptionIds = this.addedSubscriptions.map(e => e.id)
      let createInvitationPromises = this.addedUsers.map(user => this.$store.dispatch('customer/createInvitation', { email: user.email, subscriptionIds: subscriptionIds }))
      this.executeBulkOperation(createInvitationPromises)
    },

    beforeBulk: function () {
      this.inviting = true
      this.disableAll = true
    },

    handleBulkError: function (error) {
      console.error(error)
      this.$store.commit('setErrorMessages', error)
    },

    handleBulkSuccess: function (successfulInvites) {
      this.clearSuccessfullInvites(successfulInvites)
    },

    afterBulk: function () {
      this.afterInvite()
    },

    onClickClose: function () {
      this.resetData()
      this.$emit('on-close')
    },

    resetData: function () {
      this.addedUsers = []
      this.addedSubscriptions = []
      let childComponents = [this.$refs.subscriptionsToAddList, this.$refs.usersToAddList, this.$refs.addedSubscriptionsList, this.$refs.addedUsersList, this.$refs.emailForm]
      for (let child of childComponents) {
        this.resetChildComponentData(child)
      }
    },

    clearSuccessfullInvites: function (invites) {
      for (let x of invites) {
        const isMatchingEmail = (invite) => invite.email === x.email
        let index = this.addedUsers.findIndex(isMatchingEmail)
        if (index >= 0) {
          this.addedUsers.splice(index, 1)
        }
      }
    },

    afterInvite: function () {
      this.disableAll = false
      this.inviting = false
      if (this.addedUsers.length === 0) {
        this.onClickClose()
      }
    },

    resetChildComponentData: function (child) {
      // Todo: Check if function exists on child
      if (child !== undefined) {
        child.resetData()
      }
    },

    addUser: function (user) {
      if (this.addedUsers.length === 0) {
        this.addedUsers.push(user)
      } else {
        let email = user.email
        if (!this.addedUsers.some(e => e.email === email)) {
          this.addedUsers.unshift(user)
        }
      }
    },

    addSubscription: function (subscription) {
      let id = subscription.id
      if (!this.addedSubscriptions.some(e => e.id === id)) {
        this.addedSubscriptions.unshift(subscription)
      }
    },

    removeSubscription: function (item) {
      this.removeItemFromList(item, this.addedSubscriptions)
    },

    removeEmail: function (item) {
      this.removeItemFromList(item, this.addedUsers)
    },

    removeItemFromList: function (item, list) {
      let index = list.findIndex(function (listItem) {
        return item.id === listItem.id
      })
      if (index >= 0) {
        list.splice(index, 1)
      }
    },

    onAddUsersManually: function (formData) {
      let emailString = formData.email.replace(/\s+/g, '')
      let emailList = emailString.split(',')
      for (let index in emailList) {
        if (!this.addedUsers.some(e => e.email === emailList[index])) {
          this.addedUsers.unshift({ id: 'newUser' + emailList[index], email: emailList[index] })
        }
      }
      this.$refs.emailForm.resetData()
    }
  },

  computed: {
    subscriptionsToAdd () {
      if (this.addedSubscriptions.length === 0) {
        return this.subscriptionsData
      } else {
        let difference = JSON.parse(JSON.stringify(this.subscriptionsData))
        let addedSubs = this.addedSubscriptions
        for (let i in addedSubs) {
          let index = difference.findIndex(function (item) {
            return item.id === addedSubs[i].id
          })
          if (index >= 0) {
            difference.splice(index, 1)
          }
        }
        return difference
      }
    },

    usersToAdd () {
      if (this.addedUsers.length === 0) {
        return this.usersData
      } else {
        let difference = JSON.parse(JSON.stringify(this.usersData))
        let addedUsers = this.addedUsers
        for (let i in addedUsers) {
          let index = difference.findIndex(function (item) {
            return item.email === addedUsers[i].email
          })
          if (index >= 0) {
            difference.splice(index, 1)
          }
        }
        return difference
      }
    },
    subscriptionsData () {
      return this.$store.state.customer.allSubscriptions.data == null ? [] : this.$store.state.customer.allSubscriptions.data
    },
    subscriptionsError () {
      return this.$store.state.customer.allSubscriptions.error == null ? '' : this.$store.state.customer.allSubscriptions.error
    },
    subscriptionsLoading () {
      return this.$store.state.customer.allSubscriptions.data == null && this.$store.state.customer.allSubscriptions.error == null
    },
    usersData: function () {
      return this.$store.state.customer.allUsersWithSubscription.data === null ? [] : this.$store.state.customer.allUsersWithSubscription.data
    },
    usersError: function () {
      return this.$store.state.customer.allUsersWithSubscription.error === null ? '' : this.$store.state.customer.allUsersWithSubscription.error
    },
    usersLoading: function () {
      return this.$store.state.customer.allUsersWithSubscription.data === null && this.$store.state.customer.allUsersWithSubscription.error === null
    }
  }
}
</script>

<style scoped>

</style>
